import React from "react";
import "../OpalAccountInfoDetails.css";

const OpalAccountTerritorialConfiguration = ({ data }) => {
    return (
        <div className="opal-info-details">
            <div className="opal-row">
                <div className="opal-cell label">Ter. Region</div>
                <div className="opal-cell value">{data?.region?.code}</div>
            </div>
            <div className="opal-row">
                <div className="opal-cell label">Ter. District</div>
                <div className="opal-cell value">{data?.district?.description}</div>
            </div>
            <div className="opal-row">
                <div className="opal-cell label">Territory</div>
                <div className="opal-cell value">{data?.territory?.description}</div>
            </div>
        </div>
    );
};

export default OpalAccountTerritorialConfiguration;
